export default __webpack_public_path__ + "static/media/telegram.18002451.svg";